import { render, staticRenderFns } from "./G_020_JuchuEntry.vue?vue&type=template&id=99747548&scoped=true&"
import script from "./G_020_JuchuEntry.vue?vue&type=script&lang=ts&"
export * from "./G_020_JuchuEntry.vue?vue&type=script&lang=ts&"
import style0 from "./G_020_JuchuEntry.vue?vue&type=style&index=0&id=99747548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99747548",
  null
  
)

export default component.exports